import { Box } from "@mui/material";
import { Dayjs } from "dayjs";
import type { DateFilterType } from "@/utils/interfaces";
import { ViewHeader } from "@/components/schedule/components/ViewHeader";

interface AdminDashboardFilterBarProps {
  selectedDate: Dayjs;
  dateFilterType: string;
  onDateChange: (date: Dayjs) => void;
  onFilterTypeChange: (type: DateFilterType) => void;
  onResetAll: () => void;
  hasActiveFilters: boolean;
}

export function AdminDashboardFilterBar({
  selectedDate,
  dateFilterType,
  onDateChange,
  onFilterTypeChange,
  onResetAll,
  hasActiveFilters,
}: AdminDashboardFilterBarProps) {
  const filterType: DateFilterType =
    dateFilterType === "year" ? "month" : (dateFilterType as DateFilterType);

  return (
    <Box sx={{ position: "sticky", top: 0, zIndex: 10 }}>
      <ViewHeader
        dateFilter={selectedDate}
        filterType={filterType}
        setDateFilter={onDateChange}
        setFilterType={onFilterTypeChange}
        showAdminFilters={false}
        filtersAlign="center"
        onReset={hasActiveFilters ? onResetAll : undefined}
        resetButtonProps={{ tooltip: "Voltar ao mês atual" }}
      />
    </Box>
  );
}
